export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const UPDATE_PROFILE = "UPDATE_PROFILE";

export const AUTH_SET_LOADING = "AUTH_SET_LOADING";
export const AUTH_NOTIFICATION = "AUTH_NOTIFICATION";
export const COUPON_LOADER = "COUPON_LOADER";
export const REG_LOADER = "REGISTER_LOADER";

export const COURSE_HOLES = "COURSE_HOLES";
export const SELECTED_COURSE = "SELECTED_COURSE";
export const COURSES = "COURSES";
export const QUICK_SEARCH = "QUICK_SEARCH";
export const COURSE_LOADER = "COURSE_LOADER";
export const LOAD_MORE_COURSES = "LOAD_MORE_COURSES";

// API Access (static#49). NOTE: no type here ever carries the IAM secret —
// see src/utils/apiAccessSafety.js.
export const API_ACCESS_LOADING = "API_ACCESS_LOADING";
export const API_ACCESS_SAVING = "API_ACCESS_SAVING";
export const API_ACCESS_SET = "API_ACCESS_SET";
export const API_ACCESS_ERROR = "API_ACCESS_ERROR";

// API usage panel (static#9).
export const API_USAGE_LOADING = "API_USAGE_LOADING";
export const API_USAGE_SET = "API_USAGE_SET";
export const API_USAGE_ERROR = "API_USAGE_ERROR";

export const STATES = "STATES";
export const CITIES = "CITIES";
export const COUNTRIES = "COUNTRIES";
